import { Sort } from 'components/atoms/Table/table.types';
import useTableQuery from 'hooks/tableQuery/useTableQuery';
import tableState from 'store/tableState/tableState.store';
import { WorkspaceCacheKeys } from 'types/cacheKeys.types';
import { getSentWorkspaceInvitations } from 'api/v3/access/workspace';
import useWorkspaceDetails from 'hooks/useWorkspaceDetails';

const useTableState = tableState({
  filtersData: {},
  tableSorter: { cellId: 'email', direction: Sort.desc },
});

export const useSentWorkspaceInvitationsWithPaging = (): ReturnType<
  typeof useTableQuery
> => {
  const { hasWorkspaceContext, workspaceId } = useWorkspaceDetails();
  const tableState = useTableState();
  return useTableQuery({
    tableState,
    cacheKey: [WorkspaceCacheKeys.SentInvitations, workspaceId],
    onFetch: (params) =>
      getSentWorkspaceInvitations({
        ...params,
        per_page: 25,
      }).then(({ invitations, paging }) => ({
        data: invitations, // Map invitations to data for consistency with table query
        paging,
      })),
    enabled: hasWorkspaceContext,
  });
};
